<ef-process-detail [process]="process$ | async"></ef-process-detail>
<ef-loading
    [loading]="IsLoading"
    loadingText="Loading..."
></ef-loading>
<ef-employee-validation-presenter
    [employees]="this.EmployeeValidationModel$ | async"
    [paycodes]="this.PayrollValidationModel$ | async"
    [nameOrder]="this.nameOrder$ | async"
    [lastSyncLists]="this.lastSyncLists$ | async"
    [lastValidationRun]="this.lastValidation$ | async"
    [loading]="IsLoading"
    [validationCompleteDate]="validationCompleteDate$ | async"
    [userInfo] = "userInfo$ | async"
    (Validate)="onValidate()"
    (Complete)="onComplete()"
></ef-employee-validation-presenter>
